import styled from 'styled-components';
import { Field } from '@app/src/components/Field';

export const FormField = styled(Field)`
  label {
    font-size: 14px;
  }
`;
